import React, { Component } from "react";
import { Container, Row, Col, Image, Collapse, Form, FormControl } from 'react-bootstrap';
// import CheckIcon from '@material-ui/icons/Check';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Button } from '@material-ui/core';
import CircularProgress from "@material-ui/core/CircularProgress";
import { Events, scrollSpy, scroller } from 'react-scroll';

import { colorPens } from './utils/colors';
import RecipeList from './component/RecipeList';

// var Parse = require('parse');

import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

const MARUKO = 'm-a-r-u-k-o';

class Ball extends Component {
    constructor(props) {
        super(props);

        let rawSearchKeywords, parsedKeywords, page;
        try {
            if (this.props.match.params.page === undefined || this.props.match.params.page === null) {
                page = 1;
            } else {
                page = parseInt(this.props.match.params.page);
                if (page < 1) {
                    page = 1;
                }
            }
            console.log(`parsed page = ${page}`);
            rawSearchKeywords = this.props.match.params.keywords;
            parsedKeywords = rawSearchKeywords.split(' ');
        } catch (error) {
            console.log(`${error.message}`);
            rawSearchKeywords = null;
            parsedKeywords = null;
            page = 1;
        }

        console.log(`${JSON.stringify(this.props)}`);

        this.state = {
            searchKeywords: rawSearchKeywords,
            keywords: parsedKeywords,
            page: page,
            itemsPerPage: 10,
            searchResults: null,
            paginationBar: null,
            searchResultLoaded: false
        }

        this.handleSearch = this.handleSearch.bind(this);
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
    }

    handleSearch(e) {
        // let form = e.currentTarget;

        e.preventDefault();
        e.stopPropagation();

        if (this.state.searchKeywords === undefined || this.state.searchKeywords === null || this.state.searchKeywords.length < 3) {
            alert('Search keywords need to be more than 3-character long.');
        }
        //  else {
        //     this.setState({ validated: true });
        // }
        else {
            // Google Analytics event
            window.gtag('event', "interact", {
                send_to: ['G-R32TQ4L14R'],
                event_category: "search",
                event_action: "new_query",
                event_label: "keywords",
                value: this.state.keywords
            });

            // this.setState({ keywords: this.state.searchKeywords.split(' ') }, () => {
            //     this.performSearch();
            // });
            // window.location.href = `/search/${this.state.searchKeywords}`;
            this.props.history.push(`/search/${this.state.searchKeywords}`);
            this.performSearch();
        }
    }

    handleKeywordChange(e) {
        // window.location.href = '/search';
        this.setState({ searchKeywords: e.target.value });
    }

    handlePreviousPage() {
        this.setState((state) => {
            return { page: state.page - 1 }
        }, () => {
            // Google Analytics event
            window.gtag('event', "interact", {
                send_to: ['G-R32TQ4L14R'],
                event_category: "search",
                event_action: "prev_page",
                event_label: "keywords",
                value: this.state.keywords
            });

            this.props.history.push(`/search/${this.state.searchKeywords}/${this.state.page}`);
            this.performSearch();
        });
    }

    handleNextPage() {
        this.setState((state) => {
            return { page: state.page + 1 }
        }, () => {
            // Google Analytics event
            window.gtag('event', "interact", {
                send_to: ['G-R32TQ4L14R'],
                event_category: "search",
                event_action: "next_page",
                event_label: "keywords",
                value: this.state.keywords
            });

            this.props.history.push(`/search/${this.state.searchKeywords}/${this.state.page}`);
            this.performSearch();
        });
    }

    async performSearch() {
        let data = {
            sk: this.state.searchKeywords,
            n: this.state.itemsPerPage,
            p: this.state.page
        }

        try {
            let thisEndpoint;

            if (data.sk === MARUKO) {
                thisEndpoint = 'random-recipes';
            } else {
                thisEndpoint = 'find-recipes';
            }

            this.setState({ searchResultLoaded: false });
            let response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/v1/${thisEndpoint}`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                throw Error(response);
            } else {
                let result = await response.json();
                // console.log(`result = ${JSON.stringify(result)}`);

                let previousButton = null;
                let nextButton = null;
                if (this.state.page > 1) {
                    previousButton = <Button onClick={() => { this.handlePreviousPage(); }}><NavigateBeforeIcon />Previous</Button>;
                }
                if (result.recipes !== undefined && result.recipes.length > this.state.itemsPerPage) {
                    nextButton = <Button onClick={() => { this.handleNextPage(); }}>Next <NavigateNextIcon /></Button>;
                }
                let paginationBar = (
                    <Row className="justify-content-space-between align-items-center">
                        <Col>{previousButton}</Col>
                        {/* <Col md={10}>&nbsp;</Col> */}
                        <Col>{nextButton}</Col>
                    </Row>
                )

                let validResults = result.recipes !== undefined ? result.recipes.slice(0, result.recipes.length - 1) : null;
                if ((validResults === null || validResults.length === 0) && this.state.page > 1) {
                    // Forward to the first page
                    window.location.href = `/search/${this.state.searchKeywords}`;
                }

                let sanitizedSearchKeywords = this.state.searchKeywords;
                if (sanitizedSearchKeywords === MARUKO) {
                    sanitizedSearchKeywords = null;
                }
                this.setState({ searchResultLoaded: true, searchResults: validResults, paginationBar: paginationBar, searchKeywords: sanitizedSearchKeywords });
                // return result;
            }
        } catch (error) {
            alert(`Failed to complete the request. Please try later again. (${error})`);
        }
    }

    componentDidMount() {
        Events.scrollEvent.register('begin', function (to, element) {
            console.log('begin', arguments);
        });

        Events.scrollEvent.register('end', function (to, element) {
            console.log('end', arguments);
        });

        scrollSpy.update();

        // Google Analytics event
        window.gtag('event', "interact", {
            send_to: ['G-R32TQ4L14R'],
            event_category: "search",
            event_action: "query",
            event_label: "keywords",
            value: this.state.keywords
        });

        console.log(`requested keywords = ${JSON.stringify(this.state.keywords)}, page = ${this.state.page}`);
        this.performSearch();
    }

    componentWillUnmount() {
        Events.scrollEvent.remove('begin');
        Events.scrollEvent.remove('end');
    }

    render() {
        return (
            <Container fluid>
                <Row className="justify-content-center align-items-center">
                    <Col onClick={() => { window.location.href = '/'; }}>
                        {/* <h2><b>BeadMeer</b></h2> */}
                        <Image alt="BeedMeer" src={process.env.PUBLIC_URL + '/images/BeadMeer-Logo-152.png'} style={{ padding: '10px' }} fluid />
                    </Col>
                    <Col md={6}>
                        <Form md={9} className="d-flex" onSubmit={this.handleSearch}>
                            <FormControl
                                type="search"
                                placeholder="enter ingredient, technique, etc to find out!"
                                name="searchKeywords"
                                aria-label="Search"
                                // value={this.state.searchKeywords}
                                value={this.state.searchKeywords !== MARUKO ? this.state.searchKeywords : null}
                                onChange={this.handleKeywordChange}
                            />
                            <Col md={1}>&nbsp;</Col>
                            {/* <Button md={2} variant="outlined" onClick={() => { this.handleSearch(); }}>Search</Button> */}
                            <Button md={2} variant="outlined" type="submit">
                                {(this.state.searchResultLoaded === false) ?
                                    (<CircularProgress size={24} style={{ color: colorPens.search }} />) : 'Search'}
                            </Button>
                        </Form>
                    </Col>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>

                {/* <Row className="justify-content-center align-items-center">
                    <Col md={10}>
                        <span style={{ color: colorPens.primary }}>
                            <Image alt="BeedMeer" src={process.env.PUBLIC_URL + '/images/banners/Advertise Here (728x90).png'} fluid />
                        </span>
                    </Col>
                </Row> */}

                <Row className="justify-content-center align-items-center">
                    <Col md={12}>
                        <RecipeList recipes={this.state.searchResults} paginationBar={this.state.paginationBar} />
                    </Col>
                </Row>

                {(this.state.searchResultLoaded === false) ?
                    (<Row className="justify-content-center align-items-center">
                        <Col md={18}>
                            <br />
                            <CircularProgress size={64} style={{ color: colorPens.search }} />
                            <br />
                        </Col>
                    </Row>) : ''}

                {/* <br /> */}
                {/* <br /> */}
            </Container>
        );
    }
}

export default Ball;